module.exports = __webpack_public_path__ + "img/bf6f1ec.jpg";